import SearchIcon from "@/SvgIcons/SearchIcon";
import React, { useCallback, memo } from "react";
import styles from "./program-searcher.module.scss";
import Close from "@/SvgIcons/Close";
interface ProgramSearcherProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

const ProgramSearcher: React.FC<ProgramSearcherProps> = ({
  searchValue,
  setSearchValue,
}) => {
  const resetValue = useCallback((): void => {
    setSearchValue("");
  }, [setSearchValue]);

  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      setSearchValue(e.target.value);
    },
    [setSearchValue]
  );

  return (
    <div className={styles.programSearchWrapper}>
      <SearchIcon className={styles.searchIcon} color="#6d7994" />
      <input
        onChange={onChangeHandler}
        value={searchValue}
        placeholder="Search Programs"
        className={styles.searchInput}
        aria-label="Search Programs"
      />

      {searchValue && (
        <button
          className={styles.searchCloseButton}
          onClick={resetValue}
          aria-label="Clear search"
        >
          <Close className={styles.searchClose} color="#6d7994" />
        </button>
      )}
    </div>
  );
};

export default memo(ProgramSearcher);
